/**
 * Trigger: tr_exchanges_insert
 * Purpose: Update account balances when an exchange is inserted
 * Table: exchanges
 * Event: AFTER INSERT
 */
export const TR_EXCHANGES_INSERT = `
CREATE TRIGGER tr_exchanges_insert
AFTER INSERT ON exchanges FOR EACH ROW
BEGIN
  INSERT OR IGNORE INTO account_daily_balances(account_id, currency_id, balance_date)
  VALUES (new.account_id, new.currency_in_id, new.exchange_date);

  INSERT OR IGNORE INTO account_daily_balances(account_id, currency_id, balance_date)
  VALUES (new.account_id, new.currency_out_id, new.exchange_date);

  INSERT OR IGNORE INTO account_activity_dates(account_id, activity_date)
  VALUES (new.account_id, new.exchange_date);

  UPDATE account_balances
  SET exchanges_amount = exchanges_amount - new.amount_out
  WHERE account_id = new.account_id
    AND currency_id = new.currency_out_id;

  UPDATE account_daily_balances
  SET exchanges_amount = exchanges_amount - new.amount_out
  WHERE account_id = new.account_id
    AND currency_id = new.currency_out_id
    AND balance_date = new.exchange_date;

  UPDATE account_balances
  SET exchanges_amount = exchanges_amount + new.amount_in
  WHERE account_id = new.account_id
    AND currency_id = new.currency_in_id;

  UPDATE account_daily_balances
  SET exchanges_amount = exchanges_amount + new.amount_in
  WHERE account_id = new.account_id
    AND currency_id = new.currency_in_id
    AND balance_date = new.exchange_date;
END;
`;
